import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin.js";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";

import './assets/font/font.css'

import ElementPlus from 'element-plus'
import {createPinia } from 'pinia'
import 'element-plus/dist/index.css'
//without this line, PixiPlugin and MotionPathPlugin may get dropped by your bundler (tree shaking)...
gsap.registerPlugin(PixiPlugin, MotionPathPlugin);

// 字体文件
import zh_tran from './assets/langs/lang'
const app =createApp(App)
app.config.globalProperties.$zh_tran = zh_tran

// 创建Pinia实例
const Pinia = createPinia()
app.use(router).use(ElementPlus).use(Pinia).mount('#app')

